/**
 * Applikasjonskonfigurasjon
 */

// Firebase konfigurasjon
export const firebaseConfig = typeof __firebase_config !== 'undefined' 
  ? JSON.parse(__firebase_config)
  : {
      apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
      authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
      projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
      storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
      appId: import.meta.env.VITE_FIREBASE_APP_ID
    };

// App ID
export const APP_ID = typeof __app_id !== 'undefined' ? __app_id : 'lopda-v6';

// Initial auth token (hvis tilgjengelig)
export const INITIAL_AUTH_TOKEN = typeof __initial_auth_token !== 'undefined' 
  ? __initial_auth_token 
  : null;

// Avatar-emojier
export const AVATARS = [
  "🏃‍♂️", 
  "🏃‍♀️", 
  "⚡", 
  "🔥", 
  "🦁", 
  "🚀", 
  "👟", 
  "🏔️", 
  "🥇", 
  "🐺"
];

// Konkurransemodus
export const COMPETITION_MODES = {
  FIRST_TO_GOAL: 'first_to_goal',
  LONGEST_DISTANCE: 'longest_distance',
  TUG_OF_WAR: 'tug_of_war'
};

// Tidsfiltre
export const TIME_FILTERS = {
  WEEK: 'week',
  MONTH: 'month',
  YEAR: 'year'
};

// Tabs
export const TABS = {
  STATUS: 'status',
  COMPETITIONS: 'konkurranser',
  PROFILE: 'profil'
};

// Synkroniseringsinnstillinger
export const SYNC_CONFIG = {
  MAX_ACTIVITIES_PER_USER: 365,  // Maks antall aktiviteter per bruker (1 år)
  SYNC_PERIOD_MONTHS: 12,         // Hvor mange måneder tilbake å synkronisere (1 år)
  MAX_ACTIVITIES_PER_SYNC: 200    // Maks antall aktiviteter å hente per synkronisering
};
